<template>
  <el-card id="mv-edit" v-loading="loading" element-loading-text="加载中...">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      :disabled="disabledEdit"
    >
      <div class="section-title">
        基本信息
        <span v-if="form.mvId">(id: {{ form.mvId }})</span>
      </div>
      <fragment-uploader
        v-if="showUpload"
        :file-list="fileList"
        :drag="true"
        :accept="acceptList.join(',')"
        :before-upload="handleBefore"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
      >
        <el-button type="primary" size="large" style="width: 400px;">上传 / 将视频拖动到此处上传</el-button>
        <template v-slot:tip>
          <ul class="el-upload__tip">
            <li class="tip">视频格式必须为 .mp4/.webm/.flv/.ogg/.mov/.3gp/.avi/.mkv/.wmv/.mpg/.vob/.flv/.swf/.ocg/.dat/.m4v</li>
          </ul>
        </template>
      </fragment-uploader>
      <!-- v-else 展示视频预览块 -->
      <video-player
        v-else
        ref="videoPlayer"
        class-name="preview-video"
        video-class="video"
        :video-src="fileList[0] ? fileList[0].url : ''"
        :autoplay="false"
      >
      </video-player>
      <el-button v-if="fileList.length" type="danger" @click="handleRemoveVideo">移除</el-button>

      <div style="padding: 16px 0;" />

      <el-form-item label="视频名称" prop="mvName">
        <el-input
          v-model="form.mvName"
          placeholder="请输入视频名称"
          class="form-field"
          v-trans-complex="'视频名'"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属艺人" prop="mvSingerList">
        <search-singer
          :value.sync="form.mvSingerList"
          :default-options="singerOptions"
          class="form-field"
          placeholder="输入艺人名搜索"
        >
          <template v-slot:dropdown>
            <div style="padding: 8px;">找不到艺人？可以选择 <a href="/person/singer/list" target="_blank">新建艺人</a></div>
          </template>
        </search-singer>
      </el-form-item>
      <el-form-item label="发行地区" prop="area">
        <el-select v-model="form.area" filterable class="form-field">
          <el-option
            v-for="(name, key) in areaMap"
            :key="key"
            :value="+key"
            :label="name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频属性" prop="attr">
        <el-select v-model="form.attr" filterable class="form-field">
          <el-option
            v-for="(name, key) in attrMap"
            :key="key"
            :value="+key"
            :label="name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="语言" prop="language">
        <el-select v-model="form.language" filterable class="form-field">
          <el-option
            v-for="(name, key) in languageMap"
            :key="key"
            :value="+key"
            :label="name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频流派" prop="srcGenre">
        <el-select
          v-model="form.srcGenre"
          multiple
          filterable
          allow-create
          default-first-option
          class="form-field"
          placeholder="选择或创建流派"
        >
          <el-option v-for="item in srcGenreList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发行时间" prop="publicTime">
        <el-date-picker
          v-model="form.publicTime"
          type="datetime"
          class="form-field"
          placeholder="视频实际发行时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleDateChange($event, '发行时间')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="saleTime" style="">
        <span slot="label">
          上线时间
        </span>
        <div class="form-field" style="display: inline-block;">
          <el-date-picker
            v-model="form.saleTime"
            type="datetime"
            class="form-field"
            placeholder="视频上线时间"
            :disabled="!!form.mvId && form.status === 5"
            @change="handleDateChange($event, '上线时间')"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="封面图" prop="mvPhotoList">
        <el-upload
          class="upload-demo"
          action="/action/upload?type=image"
          :on-preview="handlePhotoPreview"
          :before-upload="handlePhotoBeforeUpload"
          :on-success="handlePhotoSuccess"
          :on-error="handlePhotoError"
          :file-list="form.mvPhotoList"
          :accept="'.' + imageType.join(',.')"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            >
            <span class="el-upload-list__item-actions custom-action-list">
              <span
                class="el-upload-list__item-preview"
                @click="handlePhotoPreview(file)"
              >
                <i class="el-icon-zoom-in" />
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handlePhotoRemove(file)"
              >
                <i class="el-icon-delete" />
              </span>
              <div class="photo-info-item">宽：{{ file.photoWidth }}px</div>
              <div class="photo-info-item">高：{{ file.photoHeight }}px</div>
            </span>
          </div>
          <div slot="tip" class="el-upload__tip">
            支持上传 {{ imageType.join('/') }} 文件
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="授权文件" prop="mvLicenseList">
        <el-upload
          action="/action/upload?type=license"
          :on-preview="handleLicensePreview"
          :on-remove="handleLicenseRemove"
          :on-error="hndleLicenseError"
          :on-success="handleLicenseSuccess"
          :before-upload="handleLicenseBeforeUpload"
          :file-list="form.mvLicenseList"
          :accept="'.' + licenseFileType.join(',.')"
        >
          <el-button type="primary">上传文件</el-button>
          <div slot="tip" class="el-upload__tip">支持上传 {{ licenseFileType.join('/') }} 文件</div>
        </el-upload>
      </el-form-item>

      <div class="section-title">
        版权信息
        <i v-if="notFreeCompany" class="el-icon-lock" />
        <span
          v-if="form.mvId"
          class="apply-icon"
          @click.stop="handleApply"
        >
          <i class="el-icon-key" />申请修改
        </span>
      </div>

      <el-form-item label="原始版权公司" prop="mvCopyright.originCpCompany.companyName" label-width="110px">
        <el-autocomplete
          v-model="form.mvCopyright.originCpCompany.companyName"
          :fetch-suggestions="originCompanySearch"
          :disabled="notFreeCompany"
          class="form-field"
          value-key="companyName"
          placeholder="请输入内容"
          @select="handleOriginCompanySelect"
        ></el-autocomplete>
        <el-tooltip placement="top">
          <template v-slot:content>
            原始版权公司即领接权公司，当上传内容为代理内容时需填写
          </template>
          <i class="el-icon-question area-info" />
        </el-tooltip>
      </el-form-item>
      <el-form-item label="授权起始时间" prop="mvCopyright.date" label-width="110px">
        <el-date-picker
          v-model="form.mvCopyright.date"
          :disabled="notFreeCompany"
          type="daterange"
          class="form-field"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <!-- 公司类型 2-免费授权 不显示,默认 0 -->
      <el-form-item v-show="userCompany.type !== 2 || isInnerUser" label="版权来源" prop="mvCopyright.cpSource" label-width="110px">
        <el-select
          v-model="form.mvCopyright.cpSource"
          :disabled="notFreeCompany"
          class="form-field"
          filterable
        >
          <el-option
            v-for="(name, id) in cpSourceMap"
            :key="id"
            :data-key="id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="海外总代理" prop="mvCopyright.isOverseaOnly" label-width="110px">
        <el-radio-group v-model="form.mvCopyright.isOverseaOnly" :disabled="notFreeCompany">
          <el-radio v-for="(name, id) in isOverseaMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权区域" prop="mvCopyright.copyrightArea" label-width="110px">
        <el-select
          v-model="form.mvCopyright.copyrightArea"
          :disabled="notFreeCompany"
          style="width: 400px"
          multiple
          filterable
        >
          <el-option
            v-for="(name, id) in copyrightAreaMap"
            :key="id"
            :data-key="id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
        <el-tooltip placement="top">
          <template v-slot:content>
            <ul>
              <li>选择任意地区：表示授权区域范围是【选中的地区】</li>
              <li>单选“全世界“时授权范围即为全世界；选“全世界”+其他某地区时，授权范围为全世界除其他某地区</li>
            </ul>
          </template>
          <i class="el-icon-question area-info" />
        </el-tooltip>
      </el-form-item>

      <!-- 公司类型 2-免费授权 不显示,默认 0 -->
      <el-form-item v-show="userCompany.type !== 2 || isInnerUser" label="授权形式" prop="mvCopyright.isOnly" label-width="110px">
        <el-radio-group v-model="form.mvCopyright.isOnly" :disabled="notFreeCompany">
          <el-radio v-for="(name, id) in isOnlyMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-show="form.mvCopyright.isOnly === 0" label="首发期限" label-width="110px">
        <el-date-picker
          v-model="form.firstPublicTime"
          type="datetime"
          placeholder="首发期限"
          class="form-field"
          value-format="yyyy-MM-dd HH:mm:ss"
          :disabled="notFreeCompany"
          :picker-options="firstPublicTimeOptions"
          @change="handleDateChange($event, '首发期限')"
        ></el-date-picker>
        <el-tooltip content="非必选，指从内容上线时间到首发期限时间段内为独家首发" placement="top">
          <i class="el-icon-question area-info" />
        </el-tooltip>
      </el-form-item>

      <!-- 公司类型不是 2-免费授权 and  -->
      <el-form-item
        v-show="(userCompany.type !== 2 || isInnerUser) && form.mvCopyright.isOnly === 1"
        label="可否转授权"
        prop="mvCopyright.canAuth"
        label-width="110px"
      >
        <el-radio-group v-model="form.mvCopyright.canAuth" :disabled="notFreeCompany">
          <el-radio v-for="(name, id) in canAuthMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权关系" prop="mvCopyright.isAgent" label-width="110px">
        <el-radio-group v-model="form.mvCopyright.isAgent" :disabled="notFreeCompany">
          <el-radio v-for="(name, id) in isAgentMap" :key="id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.mvId" label="追加授权文件" prop="additionLicenseList" label-width="110px">
        <el-upload
          action="/action/upload?type=license"
          :on-preview="handleLicensePreview"
          :on-remove="handleAdditionLicenseRemove"
          :on-error="hndleAdditionLicenseError"
          :on-success="handleAdditionLicenseSuccess"
          :before-upload="handleLicenseBeforeUpload"
          :file-list="additionLicenseList"
          :accept="'.' + licenseFileType.join(',.')"
        >
          <el-button type="primary">上传文件</el-button>
          <div slot="tip" class="el-upload__tip">支持上传 {{ licenseFileType.join('/') }} 文件</div>
        </el-upload>
      </el-form-item>

      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item title="填写更多信息" name="extra">
          <template #title>
            <span class="more-title">填写更多信息</span>
          </template>

          <el-form-item label="翻译名称" prop="transName">
            <el-input v-model="form.transName" placeholder="请输入翻译名" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="视频副标题">
            <el-input v-model="form.mvExtend.subTitle" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="视频版本" prop="srcVersion">
            <el-input v-model.trim="form.srcVersion" placeholder="" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="UPC" prop="upc">
            <el-input v-model="form.upc" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="ISRC" prop="isrc">
            <el-input v-model="form.isrc" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="外显厂牌公司" prop="mvExtend.displayCompanyName">
            <el-input v-model="form.mvExtend.displayCompanyName" placeholder="" class="form-field"></el-input>
          </el-form-item>
          <el-form-item label="导演">
            <el-input
              v-model.trim="form.mvExtend.director"
              v-trans-complex="'导演'"
              class="form-field"
            ></el-input>
          </el-form-item>
          <el-form-item label="编剧">
            <el-input
              v-model.trim="form.mvExtend.editor"
              v-trans-complex="'编剧'"
              class="form-field"
            ></el-input>
          </el-form-item>
          <el-form-item label="主演">
            <el-input
              v-model.trim="form.mvExtend.actor"
              v-trans-complex="'主演'"
              class="form-field"
            ></el-input>
          </el-form-item>
          <el-form-item label="制片人">
            <el-input
              v-model.trim="form.mvExtend.producer"
              v-trans-complex="'制片人'"
              class="form-field"
            ></el-input>
          </el-form-item>
          <el-form-item label="视频简介" prop="desc">
            <el-input
              v-model.trim="form.desc"
              v-trans-complex="'视频简介'"
              type="textarea"
              :rows="2"
              placeholder="请输入视频简介"
            ></el-input>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-form>

    <div class="center">
      <el-button
        :disabled="disabledEdit"
        type="primary"
        size="medium"
        @click="handleSubmit"
      >
        提 交
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { isArray, cloneDeep } from 'lodash-es'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import mvService from '@/api/mv'
import { SearchSinger, FragmentUploader } from '@/components'
import VideoPlayer from '@/components/VideoPlayer'
import { validateFileExt } from '@/utils/validate'
import { getDatetimeOrNull } from '@/utils/dateUtil'
import { ls } from '@/utils/index'
import DefaultMv from '@/models/Mv.js'
import {
  languageMap,
  attrMap,
  areaMap,
  srcGenreList,
  acceptList,
  licenseFileType,
  imageType,
  isOnlyMap,
  canAuthMap,
  isAgentMap,
  cpSourceMap,
  copyrightAreaMap,
  isOverseaMap,
  fieldNameMap,
} from './const.js'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

dayjs.extend(customParseFormat)
const toListFields = ['copyrightArea']
const copyrightFields = ['isAgent', 'canAuth', 'isOnly', 'copyrightArea', 'isOverseaOnly',
  'cpSource', 'date', 'originCpCompany', 'cpPercent']

export default {
  name: 'MvEdit',
  components: {
    FragmentUploader,
    VideoPlayer,
    SearchSinger
  },
  data() {
    return {
      languageMap,
      attrMap,
      acceptList,
      areaMap,
      srcGenreList,
      licenseFileType,
      imageType,
      isOnlyMap,
      canAuthMap,
      isAgentMap,
      cpSourceMap,
      copyrightAreaMap,
      isOverseaMap,
      activeNames: '',
      fileList: [],
      singerOptions: [],
      additionLicenseList: [],
      form: new DefaultMv(),
      rules: {
        mvName: [{ required: true, message: '请输入视频名称', trigger: 'blur' }],
        mvSingerList: [{ type: 'array', required: true, message: '请选择视频艺人', trigger: 'change' }],
        area: [{ required: true, message: '请选择视频发行地区', trigger: 'change' }],
        language: [{ required: true, message: '请选择视频语言', trigger: 'change' }],
        attr: [{ required: true, message: '请选择视频属性', trigger: 'change' }],
        srcGenre: [{ type: 'array', required: true, message: '请选择视频流派', trigger: 'change' }],
        publicTime: [
          { required: true, message: '请选择发行时间', trigger: 'blur' }
        ],
        saleTime: [
          { required: true, message: '请选择上线时间', trigger: 'blur' }
        ],
        mvPhotoList: [
          { type: 'array', required: true, message: '请上传至少一张视频封面图片', trigger: 'change' },
        ],
        mvLicenseList: [
          { type: 'array', required: true, message: '请上传授权文件', trigger: 'change' }
        ],
        'mvCopyright.date': [
          { type: 'array', required: true, message: '请选择授权时间', trigger: 'change' }
        ],
        'mvCopyright.cpSource': [
          { type: 'number', required: true, message: '请选择授权来源', trigger: 'change' }
        ],
        'mvCopyright.copyrightArea': [
          { type: 'array', required: true, message: '请选择授权区域', trigger: 'change' }
        ],
        'mvCopyright.isOnly': [
          { type: 'number', required: true, message: '请选择授权形式', trigger: 'change' }
        ],
        'mvCopyright.isOverseaOnly': [
          { type: 'number', required: true, message: '请选择是否海外总代理', trigger: 'change' }
        ],
        'mvCopyright.canAuth': [
          { type: 'number', required: true, message: '请选择是否可转授', trigger: 'change' }
        ],
        'mvCopyright.isAgent': [
          { type: 'number', required: true, message: '请选择授权关系', trigger: 'change' }
        ],
      },
      uploading: false,
      photoUploading: false,
      licenseUploading: false,
      loading: false,
      lock: true,
      firstPublicTimeOptions: {
        disabledDate: (time) => {
          const timeObj = dayjs(new Date(time))
          const saleTime = dayjs(this.form.saleTime, 'YYYY-MM-DD HH:mm:ss')

          return timeObj.isBefore(saleTime)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'originCompanyList',
      'copyrightCompanyList',
      'company'
    ]),
    /**
     * @returns {Boolean}
     */
    showUpload() {
      return this.fileList.length === 0
    },
    /**
     * @returns {Object}
     */
    userCompany() {
      return this.copyrightCompanyList[0] || {}
    },
    /**
     * @returns {Boolean}
     */
    notFreeCompany() {
      const { userCompany, form, $CONST } = this
      return !!(userCompany.type !== $CONST.CP_TYPE.FREE.code && form.mvId) && this.lock
    },
    /**
     * @returns {Boolean}
     */
    isInnerUser() {
      return ![ROLE_TYPE_ENUM.COMPANY.code, ROLE_TYPE_ENUM.OTHER.code].includes(this.userInfo.roleType)
    },
    /**
     * @returns {Boolean}
     */
    disabledEdit() {
      if (!this.$route.query.id) {
        return false
      }
      const { copyrightCompanyList, form } = this
      return form.mvCopyright.cpStatus !== 1 ||
        !form.mvCopyright.cpCompany ||
        !copyrightCompanyList.find(item => item.cpCompanyId === form.mvCopyright.cpCompany.companyId)
    },
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      this.fetchMv(id)
      return
    }

    // 检查是否存在未提交的草稿
    const mvDraft = ls.getItem('mvDraft')
    if (mvDraft) {
      this.$confirm('存在草稿数据，是否导入', '提示', {
        confirmButtonText: '导入',
        cancelButtonText: '不导入',
      }).then(_ => {
        this.form = mvDraft
        this.singerOptions = this.form.mvSingerList
      }).catch(_ => {
        ls.setItem('mvDraft', '')
      })
    } else {
      // 新增
      // 版权原始版权公司默认选中账号关联公司
      if (this.company) {
        this.form.mvCopyright.originCpCompany.companyName = this.company.companyName
        this.form.mvCopyright.originCpCompany.companyId = this.company.companyId
      }
    }
  },
  methods: {
    async fetchMv(id) {
      this.loading = true

      try {
        const resp = await mvService.findById({ mvId: +id })
        this.__reponse_time__ = resp.__reponse_time__
        resp.mvCopyright = this.toFrontend(resp.mvCopyright)
        const form = new DefaultMv(resp)
        this.form = form
        // 把已经处理过的数据保存一份, 最后对比时使用
        this.form.oldLockObj = Object.freeze(cloneDeep({
          firstPublicTime: resp.firstPublicTime,
          mvCopyright: resp.mvCopyright,
        }))
        this.fileList.push({
          ...this.form.mvMedia,
          url: this.form.mvMedia.mediaUrl
        })
        this.singerOptions = this.form.mvSingerList // 把列表赋给下拉框可选项才能显示值
      } catch (error) {
        console.error(error)
        this.$message.error('查询异常.' + error.message)
      }
      this.loading = false
    },
    toFrontend(copyright) {
      copyright.date = []
      if (copyright.copyrightTo) {
        copyright.date = [copyright.copyrightFrom, copyright.copyrightTo]
      }
      copyright.copyrightArea = copyright.copyrightArea.split(',').map(item => +item)

      return copyright
    },

    handleDateChange(time, fieldName) {
      const timeObj = dayjs(time, 'YYYY-MM-DD HH:mm:ss')
      if (timeObj.isBefore(dayjs())) {
        this.$alert(`<b>${fieldName}</b>早于当前时间，请确定输入是否正确`, '提示', {
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
    },

    handleBefore(file) {
      if (!validateFileExt(['flv', 'mp4', 'webm', 'ogg', 'mov', '3gp', 'avi', 'mkv', 'wmv', 'mpg', 'vob', 'flv', 'swf', 'ocg', 'dat', 'm4v'], file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }
      this.uploading = true
      return Promise.resolve()
    },

    handleRemoveVideo() {
      this.fileList.splice(0)
      this.form.mvMedia = null
    },

    /* 视频文件处理 */
    handleSuccess(file) {
      // console.log(file)
      const videoObj = {
        using: 1,
        url: file.url,
        mediaUrl: file.url,
        fileSize: file.size,
        fileName: file.name,
        fileType: file.type,
        fileMd5: file.md5,
        mediaPath: file.mediaPath
      }
      this.fileList.push(videoObj)
      this.uploading = false
    },
    handleExceed() {
      // console.log('exceed')
      this.$alert('只能上传一个视频文件', '提示', { type: 'warning' })
    },
    /* 视频文件处理 end */

    /* 授权文件处理 */
    hndleLicenseError(error, file, fileList) {
      this.licenseUploading = false
      this.$message({
        type: 'error',
        message: '上传授权文件异常',
        error
      })
      this.form.mvLicenseList = fileList
    },
    handleLicenseSuccess(resp, file, fileList) {
      const respData = resp.data
      const fileData = {
        url: this.$toPreview(respData.url),
        name: file.name,
        licenseUrl: respData.url,
        licensePath: respData.file_id,
        fileMd5: respData.md5,
        fileName: file.name,
      }
      this.form.mvLicenseList.push(fileData)

      this.licenseUploading = false
    },
    handleLicenseRemove(file, fileList) {
      this.form.mvLicenseList = fileList
    },
    handleLicenseBeforeUpload(file) {
      if (!validateFileExt(licenseFileType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      this.licenseUploading = true
      return Promise.resolve()
    },
    handleLicensePreview(file) {
      open(file.url, '_blank')
    },
    /* 授权文件处理 end */

    /* 追加授权文件 start */
    hndleAdditionLicenseError(error, file, fileList) {
      this.licenseUploading = false
      this.$message({
        type: 'error',
        message: '上传追加授权文件异常',
        error
      })
      this.additionLicenseList = fileList
    },
    handleAdditionLicenseSuccess(resp, file, fileList) {
      const respData = resp.data
      const fileData = {
        url: this.$toPreview(respData.url),
        name: file.name,
        licenseUrl: respData.url,
        licensePath: respData.file_id,
        fileMd5: respData.md5,
        fileName: file.name,
      }
      this.additionLicenseList.push(fileData)

      this.licenseUploading = false
    },
    handleAdditionLicenseRemove(file, fileList) {
      this.additionLicenseList = fileList
    },
    /* 追加授权文件 end */

    /* 图片处理 */
    handlePhotoBeforeUpload(file) {
      if (!validateFileExt(imageType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      this.photoUploading = true
      return Promise.resolve()
    },
    handlePhotoPreview(file) {
      open(this.$toPreview(file.url), '_blank')
    },
    handlePhotoSuccess(resp, file) {
      if (resp.code === 0) {
        const respData = resp.data
        const fileData = {
          url: respData.url,
          md5: respData.md5,
          photoPath: respData.file_id,
          photoUrl: respData.url,
          photoSize: file.size,
          photoHeight: respData.file_info.height,
          photoWidth: respData.file_info.width,
          orderIndex: this.form.mvPhotoList.length,
          using: 1,
        }
        this.form.mvPhotoList.push(fileData)
      } else {
        this.$message.error('上传异常: ' + resp.msg)
      }
      this.photoUploading = false
    },
    handlePhotoError(err) {
      this.photoUploading = false
      this.$message.error('上传失败: ' + err.message)
    },
    handlePhotoRemove(file) {
      const photoList = this.form.mvPhotoList
      const index = photoList.findIndex(item => {
        return item === file
      })
      photoList.splice(index, 1)
    },
    /* 图片处理 end */

    /**
     * 申请修改视频敏感字段
     */
    handleApply() {
      if (this.lock === false) {
        return this.$message({
          type: 'info',
          message: '已经解锁'
        })
      }
      this.$alert('版权字段修改将会生成字段修改申请单，需要审批通过才能生效，请谨慎操作！', '提示', {
        type: 'warning'
      }).then(_ => {
        this.lock = false
      }).catch(_ => {
        //
      })
    },

    originCompanySearch(queryString, cb) {
      this.form.mvCopyright.originCpCompany.companyId = void (0)
      const originCompanyList = this.originCompanyList
      const results = queryString ? originCompanyList.filter(this.createFilter(queryString)) : originCompanyList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    handleOriginCompanySelect(copyrightType, item) {
      this.form.mvCopyright.originCpCompany.companyName = item.companyName
      this.form.mvCopyright.originCpCompany.companyId = item.companyId
    },
    createFilter(queryString) {
      return (company) => {
        return (company.companyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },

    /**
     * 合同信息对象内的字段转换为后端需要的格式
     */
    cpToBackend(mvCopyright) {
      for (const toListField of toListFields) { // 需要转换的字段
        mvCopyright[toListField] = mvCopyright[toListField].join(',')
      }
      // const ocl = this.originCompanyList
      // const existCp = ocl.find(item => item.companyName === mvCopyright.originCpCompany)
      // if (existCp) {
      //   mvCopyright.originCpCompany = existCp
      // }

      // 时间格式化
      mvCopyright.copyrightFrom = getDatetimeOrNull(mvCopyright.date[0])
      mvCopyright.copyrightTo = getDatetimeOrNull(mvCopyright.date[1], '23:59:59')

      return mvCopyright
    },

    /**
     * 排序, 统一字段
     * @param {Array} singerList - 专辑艺人对象数组
     * @param {Boolean} removeId - 是否移除 ID
     */
    _transformSinger(singerList, removeId = false) {
      const newSingerList = []
      for (let i = 0; i < singerList.length; i++) {
        const singer = singerList[i]
        if (typeof singer === 'string') { // 新增的库外艺人
          const outerSinger = {
            singerName: singer,
            isOfficial: 0,
            orderIndex: i,
          }
          newSingerList.push(outerSinger)
        } else {
          const temp = cloneDeep(singer)
          temp.orderIndex = i
          if (removeId) {
            temp.id = undefined
          }
          newSingerList.push(temp)
        }
      }
      return newSingerList
    },

    async handleSubmit() {
      const { uploading, licenseUploading, photoUploading, fileList, $refs } = this
      if (uploading) {
        return this.$message.warning('视频上传中, 请上传完后提交.')
      }
      if (licenseUploading) {
        return this.$message.warning('视频授权文件上传中, 请上传完后提交.')
      }
      if (photoUploading) {
        return this.$message.warning('视频封面上传中, 请上传完后提交.')
      }
      if (fileList.length === 0) {
        return this.$message.warning('请上传视频文件.')
      }

      $refs.form.validate(async(valid) => {
        if (valid) {
          const { form, fileList } = this
          const { mvSingerList } = form

          const postData = {
            ...cloneDeep(form),
            mvId: form.mvId ? +form.mvId : void (0),
          }
          postData.srcMvId = postData.srcMvId ? postData.srcMvId : void (0)
          postData.mvMedia = fileList[0]

          // 艺人
          postData.mvSingerList = this._transformSinger(mvSingerList)

          // 经过校验的数据，保存到缓存中
          if (!postData.mvId) {
            ls.setItem('mvDraft', postData)
          }

          // 数据处理为后台需要的格式
          postData.srcGenre = postData.srcGenre.join('|')

          if (postData.mvId && this.lock === false) {
            // 解锁了, 检查是否有字段变化
            // 当前逻辑是哪怕字段修改申请 请求异常，还是可以修改视频提交成功的
            try {
              await this.checkModify(postData)
            } catch (error) {
              return
            }

            // 需要审核的字段，提交时需要以 旧的值 提交
            Object.assign(postData, postData.oldLockObj)
          }
          postData.oldLockObj = undefined

          this.cpToBackend(postData.mvCopyright)

          this.saveMv(postData)
        }
      })
    },

    /**
     * 找出视频需要审核的字段的变更记录, 提交后台
     * @param {Object} - mvObj
     */
    async checkModify(mvObj) {
      const oldLockObj = mvObj.oldLockObj
      const { mvCopyright } = mvObj
      const modifyObj = {
      }

      // 首发期限
      if (oldLockObj.firstPublicTime !== mvObj.firstPublicTime) {
        modifyObj.mv = {
          id: mvObj.mvId,
          firstPublicTime: { oldVal: oldLockObj.firstPublicTime, newVal: mvObj.firstPublicTime }
        }
      }

      // 录音版权
      const compareObj = {}
      for (const key in oldLockObj.mvCopyright) {
        const tc = oldLockObj.mvCopyright
        if (!copyrightFields.includes(key)) continue // 不使用的字段跳过

        this.compareCopyrightField(key, tc, mvCopyright, compareObj)
      }
      if (Object.keys(compareObj).length) {
        compareObj.id = oldLockObj.mvCopyright.id
        modifyObj.mvCopyright = compareObj
      }

      const modifyKeys = Object.keys(modifyObj)
      if (modifyKeys.length !== 0) {
        // 如果有变更字段
        if (modifyKeys.length) {
          // 把新增的授权文件加到接口里
          modifyObj.mvLicenseList = this.additionLicenseList.map(item => {
            return {
              url: item.licenseUrl,
              name: item.fileName,
              path: item.licensePath,
              md5: item.fileMd5,
              fileName: item.fileName,
            }
          })

          // 需要上传授权文件
          if (modifyObj.mvLicenseList.length === 0) {
            this.$alert('修改了版权相关字段，需要上传追加授权文件。', '提示', {
              type: 'warning'
            })
            return Promise.reject(false)
          }
        }
        // mvObj.mvLicenseList = mvObj.mvLicenseList.filter(item => item.id)

        modifyObj.mvId = mvObj.mvId
        mvService.applyModify(modifyObj).then(resp => {
          return Promise.resolve(true)
        }).catch(error => {
          this.$message({
            type: 'error',
            message: `提交字段修改请求异常(${error.message})`
          })
        })
      }
    },
    compareCopyrightField(key, oldTC, newTC, tempModifyObj) {
      if (key === 'date') {
        if (oldTC[key][0] !== newTC[key][0]) {
          tempModifyObj.copyrightFrom = {
            newVal: newTC[key][0] + ' 00:00:00',
            oldVal: oldTC[key][0]
          }
        }
        if (oldTC[key][1] !== newTC[key][1]) {
          tempModifyObj.copyrightTo = {
            newVal: newTC[key][1] + ' 23:59:59',
            oldVal: oldTC[key][1]
          }
        }
        return
      }
      // 数组类型处理
      if (isArray(oldTC[key])) {
        const needJoin = toListFields.includes(key)

        if (oldTC[key].length !== newTC[key].length) {
          tempModifyObj[key] = {
            oldVal: needJoin ? oldTC[key].join(',') : oldTC[key],
            newVal: needJoin ? newTC[key].join(',') : newTC[key]
          }
          return
        }
        // 长度相等, 对比每个元素, 一旦有不对应,返回
        for (let i = 0; i < oldTC[key].length; i++) {
          if (oldTC[key][i] !== newTC[key][i]) {
            tempModifyObj[key] = {
              oldVal: needJoin ? oldTC[key].join(',') : oldTC[key],
              newVal: needJoin ? newTC[key].join(',') : newTC[key]
            }
            return
          }
        }

        return null
      }

      // 原始版权公司
      if (key === 'originCpCompany') {
        if (oldTC[key].companyName !== newTC[key].companyName) {
          tempModifyObj.originCompanyName = { oldVal: oldTC[key].companyName, newVal: newTC[key].companyName }
          return
        }
        return null
      }

      // 其余字段直接对比
      if (oldTC[key] !== newTC[key]) {
        tempModifyObj[key] = {
          oldVal: oldTC[key],
          newVal: newTC[key]
        }
        return
      }

      return null
    },

    saveMv(data) {
      this.loading = true
      mvService.save(data, this.__reponse_time__).then(resp => {
        this.$autoCloseMsg(3000, {
          type: 'success',
          message: `${data.mvId ? '您的修改已成功提交，如涉及敏感字段修改还需审核！' : '创建视频成功。'}3秒后转跳回列表页。`
        })
        ls.setItem('mvDraft', '') // 保存成功, 清空离线缓存

        setTimeout(_ => {
          this.$router.push({ name: 'mvList' })
        }, 3000)
      }).catch(error => {
        // console.log(error)
        if (error.message.includes('敏感')) {
          const respData = error.data
          for (const key in respData.mv) {
            if (fieldNameMap[key]) {
              if (typeof fieldNameMap[key] === 'string') {
                return this.$alert(`您填写的 <b class="danger-word">${fieldNameMap[key]}</b> 涉及敏感，请重新填写`, '提示', {
                  type: 'warning',
                  dangerouslyUseHTMLString: true,
                })
              } else {
                const subMap = fieldNameMap[key]
                for (const subKey in error.mv[key]) {
                  if (subMap[subKey]) {
                    return this.$alert(`您填写的 <b class="danger-word">${subMap[subKey]}</b> 涉及敏感，请重新填写`, '提示', {
                      type: 'warning',
                      dangerouslyUseHTMLString: true
                    })
                  }
                }
              }
            }
          }
          // 都没命中, 就不显示字段了
          return this.$alert('您填写的信息涉及敏感，请重新填写', '提示', { type: 'warning' })
        }
        this.$message({
          type: 'error',
          message: '保存异常：' + error.message,
          error,
          duration: 5000,
        })
      }).finally(_ => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#mv-edit {
  .more-title {
    padding-left: 4px;
    border: 0;
    border-left: 3px solid #409EFF;
  }
  .form-field {
    width: 400px;
  }

  .el-upload-list__item-actions {
    .photo-info-item {
      font-size: 14px;
    }

    &.custom-action-list {
      padding-top: 30px;
    }
  }

  .center {
    margin-top: 16px;
  }

  .preview-video {
    height: 300px;
    width: 500px;
  }
  ::v-deep .video {
    height: 300px;
    width: 500px;
  }
}
ul {
  .tip {
    line-height: 1.5;
  }
}
.apply-icon {
  // position: absolute;
  // top: 5px;
  // right: 0;
  cursor: pointer;
  color: red;
}
</style>
